import styles from './coupon-list.module.sass';
import isEmpty from 'lodash/fp/isEmpty';
import classNames from 'classnames/bind';
import { CouponItem } from './coupon-item';

const cx = classNames.bind(styles);

export const CouponList = ({ coupons, className, currentTabKey }) => {
  let emptyContent = '';

  switch (currentTabKey) {
    case 'valid':
      emptyContent = '無可使用優惠';
      break;
    case 'invalid':
      emptyContent = '無已用畢或過期優惠';
      break;
    default:
      break;
  }

  if (isEmpty(coupons)) {
    return <div className={styles['empty-state']}>{emptyContent}</div>;
  }

  return (
    <ul className={cx('coupon-list', className)}>
      {coupons.map(coupon => (
        <CouponItem key={coupon.id} coupon={coupon} type={currentTabKey} />
      ))}
    </ul>
  );
};
